import { Component, OnInit } from '@angular/core';
import { ObservablesService } from '../observables.service'
import { trigger, state, style, transition, animate} from '@angular/animations';
@Component({
  selector: 'app-super-admin-layout',
  templateUrl: './super-admin-layout.component.html',
  styleUrls: ['./super-admin-layout.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(0, 0, 0)',
      })),
      state('out', style({
        transform: 'translate3d(100%, 0, 0)',
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
    trigger('backDrop', [
      state('in', style({
        display: 'block',
      })),
      state('out', style({
        display: 'none',
      }))
    ]),
  ]
})
export class SuperAdminLayoutComponent implements OnInit {
  menuState:string = 'out';
  constructor(private observables:ObservablesService) {
    this.observables.menuStatus.subscribe((data:any)=>{
       this.menuState = data.menuState
    });
  }

  ngOnInit() {
  }

  closeMenu(){
    this.observables.setMenuStatus({menuState:'out'})
  }
}
